import React                    from 'react';
//import { Dispatch }             from "redux";
//import { ActionTypes }          from 'actions/types';
import { connect }              from 'react-redux';
import { reducerType }          from 'reducer';
import { useDroppable }         from '@dnd-kit/core';
import { componentsStateType }  from 'reducer/types';

import Tens                     from 'components/Tens';


//import { SET_COMPONENTS_STATE } from 'actions';
//import { objType }              from 'types';
import handleIsOver             from 'functions/droppable/handleIsOver';
import handleNotOver            from 'functions/droppable/handleNotOver';
import box_0                    from 'images/box_0.png';
import box_1                    from 'images/box_1.png';
import box_2                    from 'images/box_2.png';
import box_3                    from 'images/box_3.png';
import box_4                    from 'images/box_4.png';
import box_5                    from 'images/box_5.png';
import box_6                    from 'images/box_6.png';
import box_7                    from 'images/box_7.png';
import box_8                    from 'images/box_8.png';
import box_9                    from 'images/box_9.png';
//import box_10                   from 'images/box_10.png';
import closedBox              from 'images/closedBox.png';
import sizes                    from 'utils/sizes';
import { makeStyles, theme }    from "makeStyles";

const arr = [box_0, box_1, box_2, box_3, box_4, box_5, box_6, box_7, box_8, box_9, closedBox];


const useStyles = makeStyles()(
  (theme) => ({
  root: {
   //  flex:           1,
     display:        'flex',
     alignItems:     'center',
     justifyContent: 'center',
     textAlign:      'center',
     height:         '100%',
     paddingLeft:    10,
     paddingRight:   10,
     borderRadius:   '0.5em',

  },
  image: {
    backgroundPosition: 'center',
    backgroundSize:     'contain',
    backgroundRepeat:   'no-repeat',
    display:            'flex',
    alignItems:         'center',
    flexFlow:           'column',
    touchAction:        'manipulation',
  // transition:         'background 0.2s'
  },
  text: {
    position:        'absolute', 
    display:         'flex',
    alignItems:      'center',
    justifyContent:  'center',
    color:           theme.blue,
    fontSize:        23,
  }
})
);

type DroppableProps = {
  variant:         string;
  wideScreen:      boolean;
  correctVal:      number;
  componentsState: componentsStateType;
}

const Droppable: React.FC<DroppableProps> = ({ 
  variant,
  wideScreen,
  correctVal,
  componentsState,
}) => {

  const { classes } = useStyles();

  const { isOver, setNodeRef } = useDroppable({
    id: `droppable${ variant }`
  });

 
  React.useEffect(() => {
    if (isOver) {
      handleIsOver(variant)
    }
    if (!isOver) {
      handleNotOver(variant)
    }
  },[variant, isOver])  


  const value = React.useMemo(() => {
    return variant === 'tens' ? componentsState.tens.value : componentsState.units.value
  },[variant, componentsState])

  const isTens = React.useMemo(() => {
    return !!variant && variant === 'tens'
  },[variant])


  const [rootStyle, imageStyle, tensVal] = React.useMemo(() => {

    

    const { bigBoxWidth, bigBoxHeight, smallBoxHeight } = sizes;
    const { draggedBox } = componentsState;
    const width          = wideScreen ? bigBoxWidth : '19vw';
    const showCorrectVal = value === -1 && componentsState.failurCount > 2;

    let image = 'none';

    if (variant === 'tens') {
      
      const showOneBox = (value === 1 || (showCorrectVal && correctVal === 1 ))
      image = showOneBox ? `url(${ closedBox })` : 'none'
    }
   
    else if (showCorrectVal) {
      image = `url(${ arr[correctVal] })`;
    }
    else {
      image = `url(${ arr[value] })`;
    }

    return[
      {
         width:  width,
         border: `2px solid ${ 
                    isOver ? 
                    (variant === 'tens' && draggedBox === 10)  ? theme.darkBlue : 
                    (variant === 'units' && draggedBox < 10)   ? theme.darkBlue : 
                    (variant === 'tens' && draggedBox < 10)    ? theme.darkRed : 
                    (variant === 'units' && draggedBox === 10) ? theme.darkRed : 
                    'transparent' :
                    'transparent'
                }`,
      },
      {
        backgroundImage: image,
        width:           width,
        height:          wideScreen ? bigBoxHeight : smallBoxHeight,
      },
      showCorrectVal ? correctVal : value
    ]
  },[isOver, value, variant, wideScreen, correctVal, componentsState]);
  
  return (
    <div 
      className = { classes.root }
      ref       = { setNodeRef } 
      style     = { rootStyle }
    >
      {
        componentsState.failurCount <= 2 && ((componentsState.tens.value <= 0 && variant === 'tens') || (componentsState.units.value <= 0 && variant === 'units')) &&
        <div className = { classes.text }>
          { variant === 'tens' ? 'עשרות' : 'יחידות' }
        </div>
      }
      <div 
        className = { classes.image }
        style     = { imageStyle }
      >
        {
          isTens &&
          <>
            {
              tensVal > 1 &&
              <Tens
                value      = { tensVal } 
                wideScreen = { wideScreen }
                position   = { 'undefined' }
              />
            } 
          {/* <DraggableTen/> */}
          </>
        }
        
      </div>
    </div>
  );
}


const mapStateToProps = (reducer: reducerType) => {
  return {
    componentsState: reducer.components
  }
};

/* 
const mapDispatchToProps = (dispatch: Dispatch<ActionTypes>) => ({
  setComponentsState: (payload: objType) => dispatch(SET_COMPONENTS_STATE(payload)),
});
 */
export default connect(mapStateToProps)(Droppable);


